import { fun_PostAction, fun_Download } from "@/api/index";
import {fun_DownloadFile} from "@/utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regBasicinfoName: null, // 项目负责人(总监)
        regulators: null, // 招标监管部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "项目负责人：",
          value: "regBasicinfoName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 表头按钮组
      btnList: [
        {
          name: "台帐导出",
          type: "success",
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "380",
          isShow: true,
          fixed: true,
        },
        {
          label: "标段数",
          prop: "section",
          width: "80",
          fixed: true,
        },
        {
          label: "操作类型",
          slotName: "type",
          fixed: true,
          width: "150"
        },
        {
          label: "项目负责人（总监）",
          prop: "regBasicinfoName",
          fixed: true,
          width: "180"
        },
        {
          label: "变更后项目负责人（总监）",
          prop: "basicinfoChangeName",
          width: "220"
        },
        {
          label: "招标人",
          prop: "corpName",
          width: "250"
        },
        {
          label: "招投标监管部门",
          prop: "regulatorsName",
          width: "300"
        },
        {
          label: "招标类别",
          prop: "tenderClassNumName",
          width: "150"
        },
        {
          label: "招标方式",
          prop: "tenderTypeNumName",
          width: "150"
        },
        {
          label: "审核时间",
          prop: "auditDate",
          width: "180"
        },
        {
          label: "审核人员",
          prop: "auditPerson",
          width: "150"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
  },

  // 模板编译完成
  mounted() {
    // 获取一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/projectManagerRecordQuery/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id,
        type: e.val.type,
      }
      // 跳转详情页面
      this.$router.push({
        path: "/projectManagerRecordQueryDetail",
        query: obj,
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "台帐导出":
          // 调用台账导出方法
          this.fun_ImportExcel();
          break;
        default:
          "";
      }
    },
    /**
     * 台帐导出的方法
     * @author shuhua
     */
    fun_ImportExcel() {
      try {
        // 请求，获取结果集
        fun_Download("/projectManagerRecordQuery/export", {
          ...this.form,
        }).then(res => {
          // 获取到Content-Disposition;filename
          let fileNames = res.headers["content-disposition"];
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
            // 关闭加载
            this.loading = false;
          } else {
            // 关闭加载
            this.loading = false;
            // 提示请求失败消息
            this.$message.error("文件不存在！");
          }
        });
      } catch {
      }
    },
  }
};
